/**
 * pdfjs-dist's build (as of 6.x) has an unconditional top-level check —
 * `if (typeof Iterator.prototype.join !== "function")` — meant to backfill the Iterator
 * Helpers proposal's `.join()` method, but it assumes the `Iterator` global already exists.
 * On any browser/webview without native Iterator Helpers support (older Safari, older
 * Chromium-based in-app browsers), `Iterator` is undefined and importing pdfjs-dist throws
 * `ReferenceError: Iterator is not defined` (Sentry issue ACADEMY-7) before the PDF viewer
 * ever runs. No pdfjs-dist release fixes this as of 6.3.289 (checked upstream).
 *
 * Import this module BEFORE `pdfjs-dist` — ES module evaluation order guarantees an earlier
 * static import's side effects run first, so this must appear above the `pdfjs-dist` import
 * in PdfViewer.tsx, not just textually near it.
 *
 * Points `Iterator.prototype` at the real shared %IteratorPrototype% (obtained from any
 * built-in iterator, e.g. an array's), the same object every native iterator/generator
 * already inherits from — not a throwaway stand-in — so pdfjs's own `.join` assignment
 * patches real iterators everywhere, exactly like a native implementation would.
 */
if (typeof (globalThis as Record<string, unknown>).Iterator === 'undefined') {
  const iteratorPrototype = Object.getPrototypeOf(Object.getPrototypeOf([][Symbol.iterator]()));
  const IteratorStub = function Iterator(this: unknown) {} as unknown as { prototype: unknown };
  IteratorStub.prototype = iteratorPrototype;
  (globalThis as Record<string, unknown>).Iterator = IteratorStub;
}
